module.exports = __webpack_public_path__ + "static/img/查看更多-线.8cb708d6.svg";